import { jsx } from 'react/jsx-runtime';
import { cn } from '../../utils/formatters.js';
import '@radix-ui/react-label';
import '../ui/button.js';
import '@radix-ui/react-progress';
import '../../contexts/AppContext.js';
import 'lucide-react';
import 'react';
import '../../lib/toast.js';
import '../ui/alert.js';
import '@radix-ui/react-avatar';
import '../ui/badge.js';
import 'react-day-picker';
import '../ui/chart.js';
import '@radix-ui/react-checkbox';
import '@radix-ui/react-collapsible';
import 'cmdk';
import '@radix-ui/react-dialog';
import '@radix-ui/react-popover';
import 'vaul';
import '@radix-ui/react-dropdown-menu';
import '../ui/radio-group.js';
import '@radix-ui/react-select';
import '@radix-ui/react-separator';
import '../ui/sidebar.js';
import 'react-toastify';
import '@radix-ui/react-switch';
import '@radix-ui/react-tabs';
import '@radix-ui/react-tooltip';
import 'react-router-dom';
import './FormPageLayout.js';
import '../form/RichTextEditor.js';
import '../../contexts/OrganizationContext.js';
import 'axios';
import '@tanstack/react-query';
import '../crud/CrudDetailView.js';
import '../crud/CrudFormView.js';
import '../../contexts/SidebarContext.js';
import '../../contexts/ThemeContext.js';
import '@dnd-kit/core';
import '@dnd-kit/sortable';
import '@dnd-kit/utilities';

/**
 * Main header container component
 * @param children - The header content
 * @param className - Additional CSS classes
 * @returns JSX element with header container
 */
const Header = ({ children, className }) => {
    return jsx("div", { className: cn('', className), children: children });
};
/**
 * Header title component for page titles
 * @param children - The title content
 * @param className - Additional CSS classes
 * @returns JSX element with styled title
 */
const HeaderTitle = ({ children, className }) => {
    return jsx("h1", { className: cn('text-3xl font-semibold tracking-tight mb-1', className), children: children });
};
/**
 * Header description component for page descriptions
 * @param children - The description content
 * @param className - Additional CSS classes
 * @returns JSX element with styled description
 */
const HeaderDescription = ({ children, className }) => {
    return jsx("p", { className: cn('text-muted-foreground', className), children: children });
};

export { Header, HeaderDescription, HeaderTitle };
//# sourceMappingURL=Header.js.map
